import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { LanguageProvider } from './contexts/LanguageContext';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { Testimonials } from './pages/Testimonials';
import { Contact } from './pages/Contact';
import { Faq } from './pages/Faq';
import { NotFound } from './pages/NotFound';
interface AppProps {
  defaultLanguage?: 'en' | 'es';
}
export function App({
  defaultLanguage = 'en'
}: AppProps) {
  return <LanguageProvider defaultLanguage={defaultLanguage} data-id="element-0" data-mp="31c1i2bzpdug9">
      <MotionConfig reducedMotion="user" data-id="element-1" data-mp="2wjqi594yq8np">
        <BrowserRouter data-id="element-2" data-mp="2wip7v6vrtq71">
          <Routes data-id="element-3" data-mp="28ufpkexrnkkn">
            <Route element={<Layout data-id="element-5" data-mp="28tmej1rry8wp" />} data-id="element-4" data-mp="28tw62tsgwo4i">
              <Route path="/" element={<Home data-id="element-7" data-mp="28sbe9bxjfjac" />} data-id="element-6" data-mp="28suw6sn6u7od" />
              <Route path="/services" element={<Services data-id="element-9" data-mp="23u9qidp62vsj" />} data-id="element-8" data-mp="23vkuadim43jn" />
              <Route path="/about" element={<About data-id="element-11" data-mp="3ik7gwiph6frp" />} data-id="element-10" data-mp="23t8heerpojdg" />
              <Route path="/testimonials" element={<Testimonials data-id="element-13" data-mp="3ijpcuzwkmx98" />} data-id="element-12" data-mp="3ikqwvtvkeu33" />
              <Route path="/contact" element={<Contact data-id="element-15" data-mp="3mkhmhu9cv461" />} data-id="element-14" data-mp="3mlawd43m29se" />
              <Route path="/faq" element={<Faq data-id="element-17" data-mp="3rc9em985thya" />} data-id="element-16" data-mp="3mjq27fl7ksv2" />
              <Route path="*" element={<NotFound data-id="element-19" data-mp="3rdkhm6ts6loc" />} data-id="element-18" data-mp="3rbrbqtqzs5he" />
            </Route>
          </Routes>
        </BrowserRouter>
      </MotionConfig>
    </LanguageProvider>;
}